import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1c2cab4e&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=1c2cab4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cab4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2cab4e')) {
      api.createRecord('1c2cab4e', component.options)
    } else {
      api.reload('1c2cab4e', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=1c2cab4e&scoped=true&", function () {
      api.rerender('1c2cab4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Header.vue"
export default component.exports